import $ from 'jquery';

export default function getHeaderOffset(header) {
  const headerNavigation = header.querySelector('[data-site-navigation]');
  const headerMain = header.querySelector('[data-site-header-main]');
  const headerRect = header.getBoundingClientRect();
  const isSticky = headerMain.hasAttribute('data-site-header-sticky');

  if (isSticky) {
    let offset = headerMain.getBoundingClientRect().height;

    if ($(header).hasClass('site-header-sticky--open')) {
      offset = offset + headerNavigation.getBoundingClientRect().height;
    }
    return offset;

  } else {
    return headerRect.bottom >= 0 ? headerRect.bottom : 0;
  }
}
